import React, { useState } from 'react'

import CardsProgressSteps from '../../../../components/ProgressStep/CardsProgressSteps';

import chooseCardIcon from '../../../../assets/img/icon/card_icon3.png';
import chooseCardIcon1 from '../../../../assets/img/icon/card_verve-card.png';
import chooseCardIcon2 from '../../../../assets/img/icon/card_credit-card.png';
import chooseCardIcon3 from '../../../../assets/img/icon/card_bitcoin-credit-card.png';
import { useLocation, useNavigate } from 'react-router-dom';

// import '../../Cards/cards.css';

const cardOptions = [
  { id: 1, slug: "local", name: "Local Transfer", description: "Send money seamlessly within your country — fast, secure, and reliable.", icon: chooseCardIcon1 },
  { id: 2, slug: "international", name: "International Transfer", description: "Easily transfer money across borders with competitive rates and global reach.", icon: chooseCardIcon2 },
];

const SendMoney1 = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const navigate = useNavigate();
  

  const handleContinue = () => {
    if (selectedCard) {
      const selectedTransferLocation = cardOptions.find(card => card.id === selectedCard);
      navigate("/user/send_money/step1", { state: { selectedTransferLocation } });
    }
  }

  return (
    <section className='create__card__page ' style={{ paddingTop: "50px" }}>
      <section><CardsProgressSteps currentStep={1} stepLabels={["Recipient", "Amount", "Review/Pay", "Success"]} /></section>

      <section className="choose__card-section ">
        <div className="container">
          <div className='create_card_header'>
            {/* <div className="d-flex align-items-center gap-3 ps-1 ps-md-4">
              <img src={chooseCardIcon} alt="icon" width="30px" height="30px" className='img-fluid' />
              <h4 className='mb-0'>Choose Card Type</h4>
            </div> */}
          </div>

          <div className="create-card_section card-selection my-5" style={{ maxWidth: "500px", margin: "0 auto" }}>
            {/* Card Selection */}
            <div className="card-selection-container">
              {cardOptions.map((card) => (
                <div
                  key={card.id}
                  className={`card-option ${selectedCard === card.id ? "active" : ""}`}
                  onClick={() => setSelectedCard(card.id)}
                >
                  <img src={card.icon} alt={card.name} className="card-icon" />
                  <h5 className="card-title">{card.name}</h5>
                  <p className="card-description">
                    {card.description}
                  </p>
                  <div className="radio-button">
                    <div className={`radio-dot ${selectedCard === card.id ? "checked" : ""}`} />
                  </div>
                </div>
              ))}
            </div>

            {/* Continue Button */}
            <div className="d-flex align-items-center justify-content-center mt-4">
              <button onClick={handleContinue} className="btn primary__btn w-100" disabled={!selectedCard}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </section>
    </section>
  )
}

export default SendMoney1;